<template>
  <div class="similar_popup_box" v-show="similarVisible">
    <!-- 回跳到公众号详情弹窗 -->
    <official-account-popup
      :isVisible="isVisible"
      :loadingVisible="loadingVisible2"
      :data="detailData"
      :pagingData="pagingData"
      v-if="isDetailsShow"
      @closeClick="closeClick"
    ></official-account-popup>
    <!-- 回跳到相似文章弹窗 -->
    <similar-articles-popup
      :similarData="lookSimilarData"
      :loadingVisible="loadingVisible2"
      :similarVisible="lookSimilarVisible"
      v-if="isSimilarShow"
      style="margin-left: 0; margin-top: 0"
      @similarCloseClick="lookSimilarCloseClick"
      @lookDetails="lookDetails"
    ></similar-articles-popup>
    <!-- 分组管理 -->
    <group-management
      style="margin-left: calc(50% / 2 - 540px / 2); margin-top: 100px"
      :managementVisible="managementVisible"
      :manageData="manageData"
      :handel="['添加收藏', '删除', '新建分组']"
      @closeManagementClick="closeManagementClick"
    >
    </group-management>
    <div class="similar_popup">
      <h1>相似公众号</h1>
      <img :src="close" alt="关闭" @click="similarCloseClick()" class="close" />
      <div class="similar_detias">
        <div class="similar_detias_subject">
          <img
            class="similar_detias_img"
            :src="similarData.avatar"
            alt="similarData.name"
            v-if="similarData"
          />
          <img
            class="similar_detias_img"
            :src="similarData.commonPIC"
            alt="similarData.name"
            v-else
          />
          <span class="similar_detias_infor">
            <span class="similar_vxname">
              <span v-if="similarData.name">{{ similarData.name }}</span>
              <span v-else>{{ similarData.mp_name }}</span>
              <span v-if="similarData.wx">{{ similarData.wx }}</span>
              <span v-else>{{ similarData.wxid }}</span>
            </span>
            <span class="similar_owner">
              <span class="owner">
                <span style="color: #333">账号主体：</span>
                <span style="color: #999" v-if="similarData.owner">{{
                  similarData.owner
                }}</span>
                <span style="color: #999" v-else>{{ similarData.zhuti }}</span>
              </span>
              <span v-if="similarData.same_owner" class="same_owner">
                同主体公众号{{ similarData.same_owner }}个
              </span>
              <span v-else class="same_owner">同主体公众号0个</span>
            </span>
            <span class="similar_desc"> 描述：{{ similarData.desc }} </span>
          </span>
          <span class="similar_index">
            <span class="similar_index_top">
              <span>极致了指数
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="left"
                >
                <div slot="content" style="font-size:14px;float:right">极致了指数是系统基于公众号的文章数、传播指数、风险指数、<br>热点指数等数据分析得出的综合评分；指数越高标示账号质量越好。<br>极致了指数
              = (综合指数 * 100 / 月发文数) / 100</div>
                  <img
                    src="@/common/assets/tisi.png"
                    style="
                      width: 20px;
                      height: 20px;
                      display: inline-block;
                      margin-left: 10px;
                      vertical-align: middle;
                      cursor: pointer;
                    "
                  />
                  </el-tooltip></span><br />
              <span>{{ similarData.dajiala_index }}</span>
            </span>
            <span class="similar_index_class">
              <!-- <span v-for="(tag, index) in similarData.tag" :key="index">{{
              tag
            }}</span> -->
            </span>
          </span>
        </div>
        <div class="similar_detias_sort">
          <span>排序方式：</span>
          <span>
            <span
              v-for="(sortOrder, index) in sortOrder"
              :key="index"
              class="sort_order"
              @mouseenter="sortMouseenterFun(sortOrder, index)"
              @mouseleave="sortMouseleaveFun(sortOrder, index)"
              @click="sortClickFun(sortOrder, index)"
              :class="
                sortMouseNum == index || sortClickNum == index
                  ? 'sort_order_active'
                  : ''
              "
            >
              {{ sortOrder }}
            </span>
            <!-- <span>匹配程度</span>
          <span>预估活跃粉丝数</span>
          <span>头条平均点赞</span>
          <span>头条平均阅读</span>
          <span>周发文篇数</span>
          <span>极致了指数</span> -->
          </span>
        </div>
        <div class="similar_detias_title">
          <span>同主体公众号</span>
          <span>共搜索到{{ similarData.total }}结果</span>
        </div>
        <!-- {{ similarData }} -->
        <div class="similar_list" v-show="loadingVisible">
          <div
            v-for="(accounts, index) in similarData.accounts"
            :key="index"
            class="similar_bg"
            v-if="similarData.VIPLimit"
          >
            <div class="similar_bgLeft">
              <div class="similar_bgLeft_top">
                <img
                  :src="accounts.avatar"
                  alt="accounts.wxid"
                  class="accounts_img"
                />
                <div class="account_content">
                  <span class="account_content_left">
                    <span class="account_content_1">
                      <span>{{ accounts.mp_name }}</span>
                      <span>{{ accounts.wxid }}</span>
                      <img :src="accounts.qrcode" alt="微信二维码" 
                      @mousemove="ewmMethod(index)"
                        @mouseout="ewmMethod(-1)"/>
                      <span style="padding:2.5px 5px;color:#fff">订阅号</span>
                      <div class="erwm" v-show="mouseShow == index">
                        <img :src="accounts.qrcode" alt="微信二维码" />
                        <span>微信扫一扫关注他</span>
                      </div>
                    </span>
                    <span class="account_content_2">
                      <span>账号主体：{{ accounts.zhuti }}</span>
                      <span style="cursor: pointer;">同主体公众号{{ accounts.same_owner }}个</span>
                    </span>
                  </span>
                  <span class="account_content_right">
                    <span>极致了指数
                      <el-tooltip
                  class="item"
                  effect="dark"
                  placement="left"
                >
                <div slot="content" style="font-size:14px;float:right">极致了指数是系统基于公众号的文章数、传播指数、风险指数、<br>热点指数等数据分析得出的综合评分；指数越高标示账号质量越好。<br>极致了指数
              = (综合指数 * 100 / 月发文数) / 100</div>
                  <img
                    src="@/common/assets/tisi.png"
                    style="
                      width: 20px;
                      height: 20px;
                      display: inline-block;
                      margin-left: 10px;
                      vertical-align: middle;
                      cursor: pointer;
                    "
                  />
                  </el-tooltip>
                    </span>
                    <span>{{ accounts.dajiala_index }}</span>
                  </span>
                  <span class="account_content_3">
                    简介：{{ accounts.desc }}
                  </span>
                </div>
              </div>
              <div class="similar_bgLeft_bottom">
                <span class="similar_bgLeft_bottomLeft">
                  <span class="span1">
                    <span>预估活跃粉丝数</span>
                    <span>{{ accounts.fans }}</span>
                  </span>
                  <span class="span1">
                    <span>头条平均阅读</span>
                    <span>{{ accounts.fans }}</span>
                  </span>
                  <span class="span1">
                    <span>头条平均点赞</span>
                    <span>{{ accounts.fans }}</span>
                  </span>
                  <span class="span1">
                    <span>周发文数量</span>
                    <span>{{ accounts.fans }}</span>
                  </span>
                  <span class="span1">
                    <span>极致了数据</span>
                    <span>{{ accounts.fans }}</span>
                  </span>
                </span>
                <span class="similar_bgLeft_bottomRight">
                  <!-- <div>
                    <span v-if="accounts.industry"
                      >所属行业：{{ accounts.industry }}</span
                    >
                    <span v-else>所属行业：</span>
                    <span v-if="accounts.area"
                      >运用地区：{{ accounts.area }}</span
                    >
                    <span v-else>运用地区：</span>
                  </div> -->
                </span>
              </div>
            </div>
            <div class="similar_bgRight">
              <span @click="lookDetailsClick(accounts, index)">查看详情</span>
              <span @click="lookSimilatClick(accounts, index)">查看相似号</span>
              <span @click="managementClick(accounts, index)">加入收藏</span>
            </div>
          </div>
          <!-- 会员等级不足提示问题 -->
          <div class="popup_page_handle" v-else>
            <div
              class="popup_page_VIPLimit"
              style="
                width: 100%;
                height: 300px;
                // border: solid 1px;
                font-size: 24px;
                line-height: 300px;
                text-align: center;
                cursor: pointer;
              "
            >
              会员等级不足，<span @click="VIPLimit()" style="color: red"
                >前往升级会员</span
              >
            </div>
          </div>
        </div>
        <div class="similar_list" v-show="!loadingVisible">
          <img
            :src="loading_img"
            alt="动画"
            style="width: 80%; margin-left: calc(100% / 2 - 80% / 2)"
          />
        </div>
        <!-- 底部分页按钮 -->
        <div class="paging_bottom" v-if="similarData.total">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-sizes="[20]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="similarData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "similarArticlesPopup",
  data() {
    return {
      close: require("@/common/assets/close.png"),
      loading_img: require("@/common/assets/loading_img.gif"),
      backOff: require("@/common/assets/backOff.png"),
      lookSimilarData: {},
      lookSimilarVisible: false,
      isVisible: false,
      detailData: {},
      isDetailsShow: false,
      isSimilarShow: false,
      getsimilarData: {},
      accessToken: "",
      managementVisible: false,
      manageData: {},
      commonPIC: require("@/common/assets/commonPIC.png"),
      pagingData: {},
      sortOrder: [
        "匹配程度",
        "预估活跃粉丝数",
        "头条平均点赞",
        "头条平均阅读",
        "周发文篇数",
        "极致了指数",
      ],
      sortMouseNum: -1,
      sortClickNum: -1,
      // 相似文章
      pageNum: 1,
      // sortIndex: 0,
      mouseShow:-1,
    };
  },
  props: {
    similarVisible: {
      type: Boolean,
      default: false,
    },
    similarData: {
      type: Object,
      default: () => {},
    },
    loadingVisible: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // 保存taoken
    let info = JSON.parse(localStorage.getItem("userInfo"));
    if (info) {
      this.accessToken = info.accessToken;
    }
  },
  methods: {
    ewmMethod(e){
      this.mouseShow = e;
    },
    // 相似文章底部按钮
    handleCurrentChange(num) {
      this.loadingVisible = false;
      this.pageNum = num;
      this.$http.axiosFun(
        this.$api.search.mp_similar,
        {
          mid: this.similarData.mid,
          page: this.pageNum,
          sort: this.sortClickNum,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            // 获取参数
            this.similarData.total = res.data.total;
            this.similarData.accounts = res.data.accounts;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    // 排序方式方法
    // 移入
    sortMouseenterFun(item, index) {
      this.sortMouseNum = index;
    },
    // 移出
    sortMouseleaveFun() {
      this.sortMouseNum = null;
    },
    // 点击
    sortClickFun(item, index) {
      this.loadingVisible = false;
      this.sortClickNum = index;
      if (this.pageNum) {
        this.pageNum = this.pageNum;
      } else {
        this.pageNum = 0;
      }
      this.$http.axiosFun(
        this.$api.search.mp_similar,
        {
          mid: this.similarData.mid,
          page: this.pageNum,
          sort: index,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible = true;
            // 获取参数
            this.similarData.total = res.data.total;
            this.similarData.accounts = res.data.accounts;
          } else if (res.error_code == 40002) {
            this.loadingVisible = true;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    managementClick(item, index) {
      // console.log(item);
      this.managementVisible = true;
      // 加入收藏
      this.$http.axiosFun(
        this.$api.search.group_list_ext,
        {},
        (res) => {
          if (res.error_code == 0) {
            res.data.forEach((item) => {
              // console.log(item);
              item.checkAll = false;
              item.account_list.forEach((items) => {
                items.checked = false;
              });
            });
            this.manageData = {
              manageList: res.data,
              manageElement: item,
            };
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
      // 传入需要加入收藏的元素
    },
    closeManagementClick() {
      this.managementVisible = !this.managementVisible;
    },
    // 查看详情
    lookDetails(item, index) {
      this.$emit("lookDetails", item);
    },
    lookSimilarCloseClick() {
      this.lookSimilarVisible = !this.lookSimilarVisible;
    },
    similarCloseClick() {
      this.$emit("similarCloseClick");
    },
    lookDetailsClick(item) {
      // console.log(item)
      this.loadingVisible2 = false;
      this.$http.axiosFun(
        this.$api.search.mp_detail,
        {
          mId: item.mid,
        },
        (res1) => {
          if (res1.error_code == 0) {
            this.loadingVisible2 = true;
            // 监控数量 mpaccount
            this.$http.axiosFun(
              this.$api.mpaccount.monitor,
              {
                wxid: res1.data.wx,
              },
              (res) => {
                if (res.error_code == 200) {
                  // console.log(res)
                  this.detailData = res1.data;
                  this.detailData.monitor_num = res.data;
                  // console.log(this.detailData)
                }
              },
              {
                "Content-Type": "application/x-www-form-urlencoded",
                accessToken: this.accessToken,
              }
            );
            // 二维码
            this.$http.axiosFun(
              this.$api.search.detail_statistic,
              {
                mId: res1.data.mid,
              },
              (res) => {
                if (res.error_code == 0) {
                  this.detailData.QRavatar = res.data.avatar;
                  // console.log(this.detailData);
                }
              },
              {
                accessToken: this.accessToken,
              }
            );
          }
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
          accessToken: this.accessToken,
        }
      );
      this.$http.axiosFun(
        this.$api.search.detail_pubList,
        {
          mId: item.mid,
          page: 1,
          num: 20,
        },
        (res) => {
          if (res.error_code == 0) {
            this.pagingData = {
              article_list: res.data.article_list,
              total: res.data.total,
            };
            // console.log(this.pagingData)
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
      this.isVisible = true;
      this.isDetailsShow = true;
    },
    lookSimilatClick(item) {
      this.loadingVisible2 = false;
      this.lookSimilarData = item;
      this.isSimilarShow = true;
      this.lookSimilarVisible = true;
      // 点击获取数据 mp_similar
      this.$http.axiosFun(
        this.$api.search.mp_similar,
        {
          mid: item.mid,
        },
        (res) => {
          if (res.error_code == 0) {
            this.loadingVisible2 = true;
            // 是否显示默认参数
            // 获取参数
            this.lookSimilarData = {
              total: res.data.total,
              accounts: res.data.accounts,
              avatar: item.avatar,
              area: item.area,
              collect_count: item.collect_count,
              dajiala_index: item.dajiala_index,
              desc: item.desc,
              group_age: item.group_age,
              group_sex: item.group_sex,
              have_owner: item.have_owner,
              is_avatar: item.is_avatar,
              is_favorite: item.is_favorite,
              zhuti: item.zhuti,
              mid: item.mid,
              monitor_num: 0,
              mp_fetch_sum: item.mp_fetch_sum,
              mp_name: item.mp_name,
              owner: item.owner,
              pubtime: item.pubtime,
              reg_time: item.reg_time,
              same_owner: item.same_owner,
              tag: item.tag,
              update_time: item.update_time,
              wxid: item.wxid,
              VIPLimit: true,
            };
            // this.lookSimilarData = item;
            this.lookSimilarData.total = res.data.total;
            this.lookSimilarData.accounts = res.data.accounts;
            this.lookSimilarData.VIPLimit = true;
            // this.$forceUpdate();
          } else if (res.error_code == 40002) {
            this.loadingVisible2 = true;
            this.lookSimilarData.VIPLimit = false;
          }
        },
        {
          accessToken: this.accessToken,
        }
      );
    },
    closeClick(data) {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="less">
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
.similar_popup_box::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  border: none;
  background-color: #fff;
}
// 分页默认样式
.el-pagination__total {
  font-size: 20px !important;
}
.el-pager li {
  font-size: 20px;
}
.number {
  font-size: 20px;
}
.similar_popup_box {
  width: 100%;
  height: 100%;
  background-color: rgba(29, 29, 29, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  // 本地分组样式
  .similar_popup {
    width: 1400px;
    height: 100%;
    background-color: #fff;
    position: fixed;
    margin-left: calc(100% / 2 - 1400px / 2);
    // margin-top: 2%;
    // margin-top: 60px;
    // z-index: 1200;
  }
  .paging_bottom {
    padding-left: 20px;
    box-sizing: border-box;
    margin-left: calc(100% / 2 - 96% / 2);
    width: 96%;
    margin-top: 30px;
    float: left;
  }
  .backOff {
    position: absolute;
    width: 30px;
    height: 30px;
    display: inline-block;
    left: 20px;
    top: 14px;
    cursor: pointer;
  }
  .similar_popup > h1 {
    width: 100%;
    height: 70px;
    box-sizing: border-box;
    // border: solid 1px #f1f1f1;
    border-top: none;
    border-left: none;
    border-right: none;
    font-size: 26px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    line-height: 70px;
    text-align: center;
    color: #000000;
  }
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
  .similar_popup > .similar_detias {
    width: 100%;
    height: 85%;
    // border: solid 1px;
    overflow-x: hidden;
    .similar_detias_subject::after {
      content: "";
      clear: both;
      display: block;
    }
    .similar_detias_subject {
      width: 100%;
      // border: solid 1px;
      padding: 0 50px;
      height: 150px;
      box-sizing: border-box;
      .similar_detias_img {
        float: left;
        // margin-top: calc(150px / 2 - 120px / 2);
        width: 100px;
        height: 100px;
        display: inline-block;
      }
      .similar_detias_infor {
        float: left;
        width: 720px;
        margin-left: 20px;
        height: 150px;
        box-sizing: border-box;
        // border: solid 1px green;
        .similar_vxname {
          width: 100%;
          // border: solid 1px red;
          display: inline-block;
          box-sizing: border-box;
          height: 30px;
          span:first-child {
            font-size: 20px;
            font-weight: 600;
            color: #333333;
            line-height: 30px;
          }
          span:nth-child(2) {
            font-size: 18px;
            font-weight: 400;
            color: #999999;
            line-height: 30px;
            margin-left: 16px;
          }
        }
        .similar_owner {
          width: 100%;
          // border: solid 1px;
          display: inline-block;
          box-sizing: border-box;
          height: 30px;
          margin-top: 10px;
          .owner {
            height: 30px;
            display: inline-block;
            line-height: 30px;
            float: left;
          }
          .same_owner {
            height: 30px;
            display: inline-block;
            line-height: 30px;
            color: #19acff;
            float: left;
            margin-left: 40px;
          }
        }
        .similar_desc {
          // border: solid 1px;
          display: inline-block;
          width: 100%;
          box-sizing: border-box;
          margin-top: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-break: break-word;
        }
      }
      .similar_index {
        width: 220px;
        // border: solid 1px;
        box-sizing: border-box;
        height: 150px;
        float: right;
        .similar_index_top {
          width: 100%;
          // border: solid 1px;
          display: inline-block;
          box-sizing: border-box;
          text-align: center;
          span:first-child {
            font-size: 20px;
            font-weight: 600;
            line-height: 38px;
          }
          span:last-child {
            color: #febb02;
            font-size: 18px;
            line-height: 30px;
          }
        }
        .similar_index_class {
          width: 100%;
          border: solid 2px #999;
          border-top: none;
          border-right: none;
          border-bottom: none;
          display: inline-block;
          box-sizing: border-box;
          margin-top: 20px;
          height: 40px;
          span {
            display: inline-block;
            width: 60px;
            height: 26px;
            margin-top: calc(40px / 2 - 26px / 2);
            margin-left: 8px;
            color: #fff;
            text-align: center;
            line-height: 26px;
            background: #21a0ff;
            border-radius: 6px;
          }
        }
      }
    }
    .similar_detias_sort {
      width: 100%;
      display: inline-block;
      // border: solid 1px;
      box-sizing: border-box;
      padding: 0 50px;
    }
    .similar_detias_sort > span:first-child {
    }
    .sort_order_active {
      width: 130px;
      border-radius: 4px;
      text-align: center;
      color: #fff;
      line-height: 30px;
      border: solid 1px #19acff;
      height: 30px;
      background-color: #19acff;
      cursor: pointer;
      display: inline-block;
    }
    .similar_detias_sort > span:nth-child(2) {
      span {
        width: 130px;
        border-radius: 4px;
        text-align: center;
        line-height: 30px;
        height: 30px;
        border: solid 1px #fff;
        cursor: pointer;
        margin-left: 10px;
        display: inline-block;
      }
    }
    .similar_detias_title::after {
      content: "";
      clear: both;
      display: inline-block;
    }
    .similar_detias_title {
      // border: solid 1px;
      width: 100%;
      display: inline-block;
      box-sizing: border-box;
      padding: 0 50px;
      margin-top: 20px;
      span:first-child {
        float: left;
        width: 130px;
        height: 30px;
        border-radius: 4px;
        text-align: center;
        line-height: 30px;
        color: #fff;
        background: #febb02;
        border-radius: 3px;
        display: inline-block;
      }
      span:last-child {
        letter-spacing: 1px;
        float: left;
        margin-left: 10px;
        height: 30px;
        line-height: 30px;
      }
    }
    .similar_list {
      width: 100%;
      // border: solid 1px;
      display: inline-block;
      margin-top: 10px;
      padding: 0 50px;
      box-sizing: border-box;
      .similar_bg {
        width: 100%;
        margin-top: 10px;
        border-radius: 8px;
        padding: 16px 26px;
        box-sizing: border-box;
        height: 260px;
        display: inline-block;
        border: solid 1px #979797;
        .similar_bgLeft {
          width: 80%;
          height: 100%;
          // border: solid 1px #cacaca;
          box-sizing: border-box;
          float: left;
          .similar_bgLeft_top::after {
            content: "";
            clear: both;
            display: block;
          }
          .similar_bgLeft_top {
            float: left;
            height: 60%;
            width: 100%;
            display: inline-block;
            border: solid 1px #cacaca;
            border-left: none;
            border-top: none;
            border-right: none;
            box-sizing: border-box;
            .accounts_img {
              border-radius: 100%;
              float: left;
              width: 76px;
              height: 76px;
              margin-top: 10px;
              box-sizing: border-box;
              display: inline-block;
            }
            .account_content {
              float: left;
              width: calc(100% - 120px);
              margin-left: 20px;
              height: 100%;
              display: inline-block;
              box-sizing: border-box;
              // border: solid 1px;
              .account_content_left {
                width: 80%;
                height: 50%;
                float: left;
                margin-top: 10px;
                // border: solid 1px;
                box-sizing: border-box;
                .account_content_1::after {
                  content: "";
                  clear: both;
                  display: inline-block;
                }
                .account_content_1 {
                  position: relative;
                  width: 100%;
                  height: 40px;
                  // border: solid 1px;
                  display: inline-block;
                  box-sizing: border-box;
                .erwm{
                  width: 160px;
                  position: absolute;
                  height:180px;
                  top:50px;
                  left:240px;
                  // border: 1px solid #000;
                  background: #fff;
                  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
                  img{
                    width: 120px;
                    height:120px;
                    display: block;
                    margin:20px auto 0;
                  }
                  span{
                    text-align: center;
                  }
                }
                  span:first-child {
                    float: left;
                    line-height: 40px;
                    color: #333;
                    font-weight: 600;
                  }
                  span:nth-child(2) {
                    float: left;
                    line-height: 40px;
                    margin-left: 10px;
                    font-size: 14px;
                    color: #999;
                  }
                  img:nth-child(3) {
                    float: left;
                    width: 20px;
                    height: 20px;
                    margin-top: 9px;
                    margin-left: 10px;
                    display: inline-block;
                  }
                  span:nth-child(4) {
                    width: 51px;
                    height: 20px;
                    background: #ff8e20;
                    font-size: 12px;
                    border-radius: 3px;
                    text-align: center;
                    // float: left;
                    line-height: 40px;
                    margin-left: 10px;
                  }
                }
                .account_content_2::after {
                  content: "";
                  display: inline-block;
                  clear: both;
                }
                .account_content_2 {
                  width: 100%;
                  display: inline-block;
                  // border: solid 1px;
                  span:first-child {
                    width: 60%;
                    display: inline-block;
                    // border: solid 1px;
                    box-sizing: border-box;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    float: left;
                  }
                  span:last-child {
                    float: left;
                    margin-left: 20px;
                    color: #19acff;
                  }
                }
              }
              .account_content_right {
                height: 50%;
                float: left;
                width: 20%;
                margin-top: 10px;
                box-sizing: border-box;
                text-align: center;
                // border: solid 1px;
                span:first-child {
                  width: 100%;
                  display: inline-block;
                  // border: solid 1px;
                  font-size: 20px;
                  font-weight: 600;
                }
                span:last-child {
                  width: 100%;
                  display: inline-block;
                  // border: solid 1px;
                  font-size: 16px;
                  color: #ff8e20;
                  margin-top: 8px;
                }
              }
              .account_content_3 {
                width: 100%;
                // border: solid 1px green;
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-top: 10px;
              }
            }
          }
          .similar_bgLeft_bottom::after {
            content: "";
            clear: both;
            display: inline-block;
          }
          .similar_bgLeft_bottom {
            float: left;
            height: 40%;
            width: 100%;
            display: inline-block;
            // border: solid 1px #cacaca;
            box-sizing: border-box;
            margin-top: 10px;
            .similar_bgLeft_bottomLeft {
              // float: left;
              width: 90%;
              margin: 0 auto;
              // border: solid 1px;
              display: flex;
              justify-content: space-around;
              box-sizing: border-box;
              text-align: center;
              line-height: 30px;
              height: 100%;
              .span1 {
                margin-top: 20px;
                span{
                  display: block;
                  width: 100%;
                  height:50%;
                  text-align: center;
                  line-height: 50%;
                }
              }
            }
            .similar_bgLeft_bottomRight {
              float: left;
              width: 20%;
              height: 100%;
              // border: solid 1px green;
              display: inline-block;
              box-sizing: border-box;
              div {
                width: 100%;
                border: solid 1px #999;
                border-top: none;
                border-right: none;
                border-bottom: none;
                display: inline-block;
                margin-top: 26px;
                box-sizing: border-box;
                padding-left: 10px;
                span {
                  width: 100%;
                  line-height: 24px;
                  color: #999;
                  // border: solid 1px;
                  display: inline-block;
                }
              }
            }
          }
        }
        .similar_bgRight {
          width: 20%;
          height: 100%;
          border: solid 1px #cacaca;
          border-top: none;
          border-right: none;
          border-bottom: none;
          box-sizing: border-box;
          float: left;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          span {
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            margin-left: calc(100% / 2 - 100px / 2);
            display: block;
            width: 120px;
            height: 40px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #cacaca;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/similar-articles-popup.vue